import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setPending(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-background" data-testid="admin-login-page">
      <div className="hidden md:block bg-secondary/50">
        <div className="h-full w-full flex flex-col justify-between p-14">
          <span className="font-serif text-2xl">Susan Denny — Fine Art</span>
          <div>
            <p className="eyebrow mb-4 text-muted-foreground">Studio</p>
            <h2 className="font-serif text-5xl font-light leading-tight">The gallery, behind the scenes.</h2>
          </div>
          <p className="eyebrow text-muted-foreground">v1 · Studio access</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <p className="eyebrow mb-3">Studio login</p>
          <h1 className="font-serif text-4xl font-light mb-10">Welcome back.</h1>

          <div className="space-y-6">
            <div>
              <label className="eyebrow mb-2 block">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="w-full bg-transparent border-b border-border focus:border-foreground py-3 outline-none"
              />
            </div>
            <div>
              <label className="eyebrow mb-2 block">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="w-full bg-transparent border-b border-border focus:border-foreground py-3 outline-none"
              />
            </div>
          </div>

          {error && <p className="text-destructive text-sm mt-6" data-testid="admin-login-error">{error}</p>}

          <button type="submit" disabled={pending} className="btn-ink w-full mt-10" data-testid="admin-login-submit">
            {pending ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
